export default {
    provinces: 'استان ها',
    provincesTitle: 'عنوان',
    provincesStatus: 'وضعیت',
    editProvinces: 'ویرایش استان ها ',
    addProvinces: 'استان جدید',
    countries: 'جست و جو بر اساس کشور',
    countriesTitle: 'کشور ها ',

}